import React, {ChangeEvent } from 'react';

interface RadioButtonProps {
    value: string;
    name: string;
    selected: boolean;
    onValueChange?: (value: string) => void;
    index?: number;
}

export const RadioButton = (props: RadioButtonProps) => {

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (props.onValueChange) {
            props.onValueChange(props.value);
        }
    };

    return (
        <div key={props.index ?? 0}>
            <label>
                <input type="radio" value={props.value} onChange={handleInputChange} checked={props.selected} /> {props.name}
            </label>
        </div>
    );
}
